module.exports = __webpack_public_path__ + "joy-static/media/FrostBorderTop.649d6320.png";